import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RatingService } from '../../../modules/photo/services/rating.service';
import { ToastrService } from 'ngx-toastr';
import { CamerallaAuthService } from '../../services/authentication-services/cameralla-auth.service';
import * as $ from 'jquery';
import { LikeService } from '../../../modules/photo/services/like.service';
import { environment } from '../../../../environments/environment';
import AppShareHelper from '../../utils/helper';
import { AdvertisingService } from "../../services/advertising.service";
import { Router } from "@angular/router";

@Component({
  selector: 'app-video-card',
  templateUrl: './video-card.component.html',
})
export class VideoCardComponent implements OnInit {
  @Input('video') video;
  @Input('photoNumber') photoNumber: number;
  @Input('newPhotos') newPhotos: number;
  @Input('classImage') classImage: any;
  @Input('hiddenRating') hiddenRating = false;
  @Input('canEdit') canEdit = false;
  @Input('fromVip') fromVip = false;
  @Output('notify') notify: EventEmitter<boolean> = new EventEmitter<boolean>();
  
  criterion = ['general', 'vision', 'composition', 'cameraSettings', 'editing', 'presentation'];
  rating = 0;
  userRating = 0;
  updateStatus = 0;
  currentRating = 0;
  public userId;
  promiseLike;
  imageManagement = {};
  source = null;
  onLoadImageError = false;
  @ViewChild('sliderComponent') sliderComponent;
  
  constructor(private _modalService: NgbModal,
              public ratingService: RatingService,
              private toastr: ToastrService,
              private authService: CamerallaAuthService,
              private likeService: LikeService,
              private advertisingService: AdvertisingService,
              private cdr: ChangeDetectorRef,
              protected router: Router,
  ) {
  }
  
  ngOnInit() {
    this.userId = +this.authService.getLocalUserInfo()['id'];
    this.userRating = (this.video.owner_rating && this.video.owner_rating.general) || 0;
    this.currentRating = this.userRating;
    if (!this.video.height || !this.video.width) {
      this.video.height = 280;
      this.video.width = 350;
    }
    
    if (environment.production) {
      AppShareHelper.convertToHttps(this.video, 'original');
      AppShareHelper.convertToHttps(this.video, 'thumbnail');
    }
  }
  
  getClassMapper(type) {
    switch (type) {
      case 1: {
        return 'primary';
      }
      case 2: {
        //statements;
        return 'secondary';
      }
      case 3: {
        //statements;
        return 'success';
      }
      case 4: {
        //statements;
        return 'danger';
      }
      case 5: {
        //statements;
        return 'warning';
      }
      case 6: {
        //statements;
        return 'info';
      }
      default: {
        //statements;
        return 'light';
      }
    }
    
  }
  
  errorPhoto() {
  }
  
  loaded() {
    setTimeout(() => {
      this.cdr.detach();
    }, 3000);
  }
  
  
  public openDetail() {
    const tempScrollTop = $(window).scrollTop();
    //Todo: Tempo fix
    localStorage.setItem( 'video-scrollPosition', tempScrollTop);
  }
  
  attachChange() {
    this.cdr.reattach();
  }
  
  detachChange() {
    this.cdr.detach();
  }
  
  preventDefault(event, photo) {
    this.advertisingService.clickingAds(photo.rawId).subscribe();
    if (!photo.navigateUrl) {
      event.preventDefault();
    } else {
      return;
    }
  }
  
  navigateToUser(entity) {
    this.router.navigate([`/user/${entity.customerId == this.userId ? 'myPage' : entity.customerId}`]);
  }
}
